'use client'

import { useFormContext } from 'react-hook-form'
import { FIELDNAMES, KNOWN_FORM_VALUES } from '../Form/utils/constants'

const mainClass = 'template__letter-in-memory'

const {
  DONATION_IN_MEMORY_RECEIVER_NAME,
  DONATION_IN_MEMORY_DATE,
  DONATOR_TYPE,
  DONATOR_FIRST_NAME,
  DONATOR_LAST_NAME,
  DONATOR_COMPANY_NAME,
  DONATOR_LETTER_FORMAT,
  DONATION_LETTER_PARTICIPANTS,
  DONATION_LETTER_RECIPIENT_COURTESY_TITLE,
  DONATION_LETTER_RECIPIENT_NAME,
  DONATION_LETTER_RECIPIENT_ADDRESS,
  DONATION_LETTER_RECIPIENT_ADDRESS_NUMBER,
  DONATION_LETTER_RECIPIENT_POSTAL_CODE,
  DONATION_LETTER_RECIPIENT_CITY,
  DONATION_LETTER_RECIPIENT_PROVINCE,
  DONATION_LETTER_RECIPIENT_COUNTRY,
  DONATION_LETTER_RECIPIENT_EMAIL,
} = FIELDNAMES

const { COMPANY, DIGITAL } = KNOWN_FORM_VALUES

const LetterPreviewBuilder = (props) => {
  const { data, useFormContextIfAvailable } = props

  const formContext = useFormContext()
  const formValues = formContext?.getValues()
  const isDigitalFormat = formValues[DONATOR_LETTER_FORMAT] === DIGITAL
  const isSingleDonator = formValues[DONATION_LETTER_PARTICIPANTS]?.length === 0
  const isCompany = formValues[DONATOR_TYPE] === COMPANY

  const today = getFormattedDate()

  const formData = {
    sender: {
      type: formValues[DONATION_LETTER_RECIPIENT_COURTESY_TITLE] || '',
      surname: formValues[DONATION_LETTER_RECIPIENT_NAME] || '',
      ...(!isDigitalFormat
        ? {
            address: formValues[DONATION_LETTER_RECIPIENT_ADDRESS] || '',
            number: formValues[DONATION_LETTER_RECIPIENT_ADDRESS_NUMBER] || '',
            cap: formValues[DONATION_LETTER_RECIPIENT_POSTAL_CODE] || '',
            city: formValues[DONATION_LETTER_RECIPIENT_CITY] || '',
            province: formValues[DONATION_LETTER_RECIPIENT_PROVINCE] || '',
          }
        : {}),
    },
    date: getFormattedDate(formValues[DONATION_IN_MEMORY_DATE]) || today,
    memoryOf: formValues[DONATION_IN_MEMORY_RECEIVER_NAME] || '',
    ...(isSingleDonator
      ? {
          group: [
            isCompany
              ? formValues[DONATOR_COMPANY_NAME]
              : `${formValues[DONATOR_FIRST_NAME]} ${formValues[DONATOR_LAST_NAME]}`,
          ],
        }
      : {
          group:
            formValues[DONATION_LETTER_PARTICIPANTS]?.map((i) => i.value) || [],
        }),
  }

  const width = 1240
  const height = 1754

  const defaultData = {
    sender: {
      type: 'Famiglia',
      surname: 'Rossi',
      address: 'Via Roma',
      number: '5',
      cap: '43127',
      city: 'Parma',
      province: 'PR',
    },
    memoryOf: 'Luca Bianchi',
    group: ['Mario Rossi', 'Maria Bianchi', 'Lucia Verdi'],
    date: today,
  }

  const currentData = useFormContextIfAvailable ? formData : data || defaultData

  const group = currentData.group ? currentData.group.join(', ') : ''

  return (
    <>
      <div className={`${mainClass}`}>
        <div
          className={`${mainClass}__container`}
          data-scale={height / width}
        >
          <p className={`${mainClass}__container__sender`}>
            Gentile {currentData.sender.type}
            <br />
            {startCase(currentData.sender.surname.toLowerCase())}
            <br />
            {currentData.sender.address} {currentData.sender.number}
            <br />
            {currentData.sender.cap} {currentData.sender.city}{' '}
            {currentData.sender.province}
            <p className={`${mainClass}__container__date`}>
              {currentData.date}
            </p>
          </p>
          <p className={`${mainClass}__container__paragraph not-indent`}>
            Gentile {currentData.sender.type}{' '}
            {startCase(currentData.sender.surname.toLowerCase())},
          </p>
          <p className={`${mainClass}__container__paragraph `}>
            Condivido oggi con voi, con sincera gratitudine che {group}
            {currentData.group.length > 1 ? ' hanno' : ' ha'} deciso di
            effettuare una generosa donazione a sostegno della ricerca
            oncologica, in memoria di {currentData.memoryOf}.
          </p>
          <p className={`${mainClass}__container__paragraph`}>
            La scelta di sostenere Fondazione AIRC in un momento difficile e di
            perdita è un gesto di grande sensibilità e profonda fiducia nella
            nostra attività e, nel sostenere il lavoro di ricercatori e
            ricercatrici, contribuisce a mantenere vivo il ricordo di chi
            abbiamo amato.
          </p>
          <p className={`${mainClass}__container__paragraph`}>
            Mi unisco con profonda partecipazione al vostro dolore, esprimendo
            le mie più sentite e sincere condoglianze.
          </p>
          <p className={`${mainClass}__container__paragraph`}>Cordialmente.</p>
        </div>
      </div>
    </>
  )
}

function getFormattedDate(customDate) {
  const getDateToday = () => {
    const today = new Date()
    return {
      day: today.getDate(),
      month: today.getMonth(),
      year: today.getFullYear(),
    }
  }

  const getMonth = (monthIndex) => {
    const months = [
      'Gennaio',
      'Febbraio',
      'Marzo',
      'Aprile',
      'Maggio',
      'Giugno',
      'Luglio',
      'Agosto',
      'Settembre',
      'Ottobre',
      'Novembre',
      'Dicembre',
    ]
    return months[monthIndex]
  }

  const today = getDateToday()
  if (customDate) {
    const [day, month, year] = customDate.split('-')
    return `${day} ${getMonth(Number(month) - 1)} ${year}`
  }
  return `${today.day} ${getMonth(today.month)} ${today.year}`
}

function startCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export default LetterPreviewBuilder
